import {
    ageCategories,
    brassAgeCategoriesSolo,
    competitionList,
    electoneAgeCategoriesSolo,
    guitarAgeCategoriesSolo,
    GuzhengInstrumentListEnsemble,
    guzhengAgeCategoriesEnsemble,
    guzhengAgeCategoriesSolo,
    harpAgeCategoriesSolo,
    InstrumentListEnsembleNew,
    percussionAgeCategoriesSolo,
    PerformanceCategory,
    stringAgeCategoriesSolo,
    vocalAgeCategoriesSolo,
    VocalChoirInstrumentEnsembleClassical,
    VocalChoirInstrumentEnsembleFreeGenre,
    woodwinAgeCategoriesSolo,
} from '../constant/RegisterPageConst.js';

const SOLO_LIMITS = {
    [competitionList.Woodwinds]: {
        PocowoodWind: 2, PetitewoodWind: 3, PrimarywoodWind: 3, YoungwoodWind: 4,
        JuniorwoodWind: 6, YouthwoodWind: 6, OpenAgewoodWind: 10,
        FreeChoicewoodWind: 10, YoungArtistwoodWind: 10,
    },
    [competitionList.Strings]: {
        PocoStrings: 2, PetiteStrings: 3, PrimaryStrings: 3, YoungStrings: 4,
        JuniorStrings: 6, YouthStrings: 6, OpenAgeStrings: 10,
        FreeChoiceStrings: 10, YoungArtistStrings: 10,
    },
    [competitionList.Piano]: {
        Poco: 2, Petite: 3, Primary: 3, Young: 4, Junior: 6, Youth: 6,
        OpenAge: 10, JuniorEtude: 8, ConcertEtude: 8, FreeChoice: 10,
        YoungArtists: 10,
    },
    [competitionList.Percussions]: {
        PocoPercussion: 2, PetitePercussion: 3, PrimaryPercussion: 3,
        YoungPercussion: 4, JuniorPercussion: 6, YouthPercussion: 6,
        OpenAgePercussion: 10, FreeChoicePercussion: 10, YoungArtistPercussion: 10,
    },
    [competitionList.Harp]: {
        PetiteHarp: 4, PrimaryHarp: 4, YoungHarp: 5, JuniorHarp: 6,
        YouthHarp: 8, OpenAgeHarp: 10, ProfessionalsHarp: 12,
        FreeChoiceHarp: 12, YoungArtistHarp: 12,
    },
    [competitionList.Guzheng]: {
        PetiteGuzheng: 6, PrimaryGuzheng: 6, YouthGuzheng: 8,
        OpenAgeGuzheng: 10, ProfessionalsGuzheng: 15, FreeChoiceGuzheng: 6,
    },
    [competitionList.Guitar]: {
        PocoGuitar: 2, PetiteGuitar: 3, PrimaryGuitar: 3, YoungGuitar: 4,
        JuniorGuitar: 6, YouthGuitar: 6, OpenAgeGuitar: 10,
        FreeChoiceGuitar: 10, YoungArtistGuitar: 10,
    },
    [competitionList.Electone]: {
        PocoElectone: 2, PetiteElectone: 3, PrimaryElectone: 3,
        YoungElectone: 4, JuniorElectone: 6, YouthElectone: 6,
        OpenAgeElectone: 6, FreeChoiceElectone: 8, YoungArtistElectone: 8,
        JuniorEtudeElectone: 8,
    },
    [competitionList.VocalChoir]: {
        PetiteVocal: 5, PrimaryVocal: 7, YoungVocal: 8, JuniorVocal: 8,
        YouthVocal: 8, OpenAgeVocal: 8, ProfessionalVocal: 10,
        FreeChoiceVocal: 8,
    },
    [competitionList.Brass]: {
        PocoBrass: 2, PetiteBrass: 3, PrimaryBrass: 3, YoungBrass: 4,
        JuniorBrass: 6, YouthBrass: 6, OpenAgeBrass: 10,
        FreeChoiceBrass: 10, YoungArtistBrass: 10,
    },
};

const SOLO_AGE_CATEGORIES = {
    [competitionList.Woodwinds]: woodwinAgeCategoriesSolo,
    [competitionList.Strings]: stringAgeCategoriesSolo,
    [competitionList.Piano]: ageCategories,
    [competitionList.Percussions]: percussionAgeCategoriesSolo,
    [competitionList.Harp]: harpAgeCategoriesSolo,
    [competitionList.Guzheng]: guzhengAgeCategoriesSolo,
    [competitionList.Guitar]: guitarAgeCategoriesSolo,
    [competitionList.Electone]: electoneAgeCategoriesSolo,
    [competitionList.VocalChoir]: vocalAgeCategoriesSolo,
    [competitionList.Brass]: brassAgeCategoriesSolo,
};

const UNIVERSAL_ENSEMBLE_CATEGORIES = [
    competitionList.Woodwinds,
    competitionList.Strings,
    competitionList.Piano,
    competitionList.Percussions,
    competitionList.Harp,
    competitionList.Guitar,
    competitionList.Electone,
    competitionList.Brass,
];

const VOCAL_ENSEMBLE_LIMITS = {
    Professionals_A: 12,
    Non_Professionals_A: 12,
    Professionals_B: 8,
    Non_Professionals_B: 8,
    Professionals_C: 12,
    Non_Professionals_C: 12,
};

const GUZHENG_ENSEMBLE_LIMITS = {
    ChineseMusicEnsemble: 10,
    GuzhengEnsemble: 10,
};

const getUniversalEnsembleAgeCategory = (instrumentCategory) => (
    instrumentCategory.includes('Non_Professionals') ? 'older_than_four' : 'nineteen_plus'
);

const createSoloRules = () => Object.entries(SOLO_AGE_CATEGORIES).flatMap(
    ([competitionCategory, categories]) => Object.keys(categories).map((ageCategory) => ({
        competitionCategory,
        performanceCategory: PerformanceCategory.Solo,
        instrumentCategory: null,
        ageCategory,
        maximumMinutes: SOLO_LIMITS[competitionCategory]?.[ageCategory],
    }))
);

const createUniversalEnsembleRules = () => UNIVERSAL_ENSEMBLE_CATEGORIES.flatMap(
    (competitionCategory) => Object.keys(InstrumentListEnsembleNew).map((instrumentCategory) => ({
        competitionCategory,
        performanceCategory: PerformanceCategory.Ensemble,
        instrumentCategory,
        ageCategory: getUniversalEnsembleAgeCategory(instrumentCategory),
        maximumMinutes: 10,
    }))
);

const createVocalEnsembleRules = () => {
    const instruments = {
        ...VocalChoirInstrumentEnsembleClassical,
        ...VocalChoirInstrumentEnsembleFreeGenre,
    };

    return Object.keys(instruments).map((instrumentCategory) => ({
        competitionCategory: competitionList.VocalChoir,
        performanceCategory: PerformanceCategory.Ensemble,
        instrumentCategory,
        ageCategory: getUniversalEnsembleAgeCategory(instrumentCategory),
        maximumMinutes: VOCAL_ENSEMBLE_LIMITS[instrumentCategory],
    }));
};

const createGuzhengEnsembleRules = () => Object.keys(GuzhengInstrumentListEnsemble).map(
    (instrumentCategory) => ({
        competitionCategory: competitionList.Guzheng,
        performanceCategory: PerformanceCategory.Ensemble,
        instrumentCategory,
        ageCategory: Object.keys(guzhengAgeCategoriesEnsemble)[0],
        maximumMinutes: GUZHENG_ENSEMBLE_LIMITS[instrumentCategory],
    })
);

export const APCS2026_VIDEO_PENALTY_RULES = [
    ...createSoloRules(),
    ...createUniversalEnsembleRules(),
    ...createVocalEnsembleRules(),
    ...createGuzhengEnsembleRules(),
];

export const APCS2026_VIDEO_PENALTY_CONFIG = {
    revision: 1,
    penaltyScore: 5,
    rules: APCS2026_VIDEO_PENALTY_RULES,
};

export const VIDEO_PENALTY_CATEGORIES = Object.values(competitionList);

export const getVideoPenaltyRuleIdentity = (rule) => ({
    competitionCategory: rule?.competitionCategory || '',
    performanceCategory: rule?.performanceCategory || '',
    instrumentCategory: rule?.instrumentCategory ?? null,
    ageCategory: rule?.ageCategory || '',
});

export const getVideoPenaltyRuleKey = (rule) => JSON.stringify(
    getVideoPenaltyRuleIdentity(rule)
);

export const getRegistrantVideoPenaltyRuleKey = (registrant) => getVideoPenaltyRuleKey({
    competitionCategory: registrant?.competitionCategory,
    performanceCategory: registrant?.PerformanceCategory,
    instrumentCategory: registrant?.PerformanceCategory === PerformanceCategory.Ensemble
        ? registrant?.instrumentCategory
        : null,
    ageCategory: registrant?.ageCategory,
});

export const findVideoPenaltyRule = (registrant, config) => {
    if (!config || !Array.isArray(config.rules)) return null;
    const registrantKey = getRegistrantVideoPenaltyRuleKey(registrant);
    return config.rules.find((rule) => getVideoPenaltyRuleKey(rule) === registrantKey) || null;
};

export const getVideoPenaltyRuleLabels = (rule) => {
    const ageMap = rule.performanceCategory === PerformanceCategory.Solo
        ? SOLO_AGE_CATEGORIES[rule.competitionCategory]
        : rule.competitionCategory === competitionList.Guzheng
            ? guzhengAgeCategoriesEnsemble
            : { older_than_four: '4+ years old (Combination Age)', nineteen_plus: '19+ years old' };

    let instrumentMap = {};
    if (rule.performanceCategory === PerformanceCategory.Ensemble) {
        if (rule.competitionCategory === competitionList.VocalChoir) {
            instrumentMap = {
                ...VocalChoirInstrumentEnsembleClassical,
                ...VocalChoirInstrumentEnsembleFreeGenre,
            };
        } else if (rule.competitionCategory === competitionList.Guzheng) {
            instrumentMap = GuzhengInstrumentListEnsemble;
        } else {
            instrumentMap = InstrumentListEnsembleNew;
        }
    }

    return {
        competitionCategoryLabel: rule.competitionCategory,
        performanceCategoryLabel: rule.performanceCategory,
        instrumentCategoryLabel: rule.instrumentCategory
            ? (instrumentMap[rule.instrumentCategory] || rule.instrumentCategory)
            : '',
        ageCategoryLabel: ageMap?.[rule.ageCategory] || rule.ageCategory,
    };
};

export const validateVideoPenaltyConfig = (config) => {
    const errors = [];
    const rules = Array.isArray(config?.rules) ? config.rules : [];
    const expectedKeys = new Set(APCS2026_VIDEO_PENALTY_RULES.map(getVideoPenaltyRuleKey));
    const seenKeys = new Set();

    if (!Number.isInteger(Number(config?.revision)) || Number(config?.revision) < 1) {
        errors.push('Configuration revision must be a positive integer.');
    }
    if (!Number.isFinite(Number(config?.penaltyScore)) || Number(config?.penaltyScore) <= 0) {
        errors.push('Penalty score must be positive.');
    }
    if (!Array.isArray(config?.rules)) {
        errors.push('Rules must be an array.');
    }

    rules.forEach((rule) => {
        const key = getVideoPenaltyRuleKey(rule);
        if (!rule || typeof rule !== 'object') {
            errors.push('Each rule must be an object.');
            return;
        }
        const isSoloRule = rule?.performanceCategory === PerformanceCategory.Solo;
        const isEnsembleRule = rule?.performanceCategory === PerformanceCategory.Ensemble;

        if (typeof rule?.competitionCategory !== 'string' || !rule.competitionCategory) {
            errors.push(`Competition category is required for ${key}.`);
        }
        if (!isSoloRule && !isEnsembleRule) {
            errors.push(`Performance category must be Solo or Ensemble for ${key}.`);
        }
        if (typeof rule?.ageCategory !== 'string' || !rule.ageCategory) {
            errors.push(`Age category is required for ${key}.`);
        }
        if (isSoloRule && rule.instrumentCategory !== null) {
            errors.push(`Instrument category must be null for Solo rule ${key}.`);
        }
        if (isEnsembleRule && (typeof rule.instrumentCategory !== 'string' || !rule.instrumentCategory)) {
            errors.push(`Instrument category is required for Ensemble rule ${key}.`);
        }
        if (seenKeys.has(key)) errors.push(`Duplicate rule: ${key}.`);
        seenKeys.add(key);
        if (!expectedKeys.has(key)) errors.push(`Unknown registration combination: ${key}.`);
        if (!Number.isFinite(Number(rule.maximumMinutes)) || Number(rule.maximumMinutes) <= 0) {
            errors.push(`Maximum minutes must be positive for ${key}.`);
        }
    });

    expectedKeys.forEach((key) => {
        if (!seenKeys.has(key)) errors.push(`Missing rule: ${key}.`);
    });

    return { isValid: errors.length === 0, errors };
};
